import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideNativeDateAdapter } from '@angular/material/core';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { MyHttpInterceptor } from './app/shared/http.interceptor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi,
} from '@angular/common/http';
import { registerLicense } from '@syncfusion/ej2-base';

if (environment.production) {
	enableProdMode();
}

if (environment.syncfusionLicense) {
	registerLicense(environment.syncfusionLicense);
}

bootstrapApplication(AppComponent, {
	providers: [
		importProvidersFrom(
			BrowserModule,
			BrowserAnimationsModule,
			FontAwesomeModule
		),
		provideRouter(routes),
		provideNativeDateAdapter(),
		provideHttpClient(withInterceptorsFromDi()),
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MyHttpInterceptor,
			multi: true,
		},
	],
}).catch(err => console.log(err));
